import { useContext } from 'react'
import { SpecificationContextState } from "./SpecificationSessionProvider";

const useSpecificationContextState = () => {
    const context = useContext(SpecificationContextState);
    if (context === undefined) {
        throw new Error("useSpecificationContextState was used outside of it's provider");
    }
    return context;
}

export { useSpecificationContextState };